<template>
  <div class="realtive h-full w-full">
    <tableButtonGroup class="mt-10px" v-model="activeTab" :list="tabList" />
    <div class="mt-20px tab-wrap">
      <!-- 基本信息start -->
      <div v-show="activeTab === '基本信息'">
        <el-form :model="baseInfoFormData" ref="formRef" label-width="100px" label-suffix=" :" disabled>
          <el-row :gutter="20">
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="8">
              <el-form-item :label="`${$t('预案编号')}`">
                <el-input size="small" v-model="baseInfoFormData.no" class="w-full"></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="8">
              <el-form-item :label="`${$t('预案名称')}`">
                <el-input size="small" v-model="baseInfoFormData.name" class="w-full" />
              </el-form-item>
            </el-col>
            <el-col
              :xs="24"
              :sm="24"
              :md="12"
              :lg="12"
              :xl="8"
              v-if="baseInfoFormData.typeName !== '综合应急预案'"
            >
              <el-form-item :label="`${$t('预案类别')}`">
                <el-input size="small" v-model="baseInfoFormData.categoryName" class="w-full" />
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="8">
              <el-form-item :label="`${$t('预案类型')}`">
                <el-input size="small" v-model="baseInfoFormData.typeName" class="w-full" />
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="8">
              <el-form-item :label="`${$t('所属部门')}`">
                <el-input
                  size="small"
                  v-model="baseInfoFormData.eascOrganizationName"
                  class="w-full"
                />
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="8">
              <el-form-item :label="`${$t('版次')}`">
                <el-input class="mr-10px" size="small" v-model="baseInfoFormData.version" />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item :label="`${$t('编制概要')}`">
                <el-input
                  type="textarea"
                  size="small"
                  :autosize="{ minRows: 2 }"
                  v-model="baseInfoFormData.summary"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <categoryTitle title="版次及记录" />
        <el-table :data="versionTableList" class="mt-20px" height="200px" ref="tableRef">
          <el-table-column :label="`${$t('序号')}`" type="index" width="50"></el-table-column>
          <el-table-column
            :label="`${$t('版次')}`"
            prop="version"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            :label="`${$t('编制与修订概要')}`"
            prop="summary"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            :label="`${$t('创建/修订人')}`"
            prop="writeName"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            :label="`${$t('创建/修订时间')}`"
            prop="creationTime"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column :label="`${$t('状态')}`" show-overflow-tooltip>
            <template #default="{ row: { status } }">
              {{ status ? statusList[status - 1].label : '' }}
            </template>
          </el-table-column>
          <el-table-column
            :label="`${$t('发布人')}`"
            prop="publisher"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column :label="`${$t('发布时间')}`" prop="publishDate" show-overflow-tooltip>
          </el-table-column>
          <el-table-column :label="`${$t('实施时间')}`" prop="executeDate" show-overflow-tooltip>
          </el-table-column>
          <el-table-column :label="`${$t('操作')}`" width="50">
            <template #default="{ row }">
              <p @click="viewLastVersion(row)" class="cursor-pointer text-[#44F1FF]">{{ $t('查看') }}</p>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 基本信息end -->

      <!-- 事故风险分析start -->
      <div v-show="activeTab === '事故风险分析'">
        <el-form :model="accidentFormData" label-width="150px" ref="accidentFormRef" disabled label-suffix=" :">
          <el-row>
            <el-col :span="24">
              <el-form-item :label="`${$t('事故类型')}`" prop="typeName">
                <el-input size="small" v-model="accidentFormData.typeName" />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item :label="`${$t('发生的区域、地点或装置的名称')}`">
                <el-input
                  type="textarea"
                  size="small"
                  :autosize="{ minRows: 2 }"
                  v-model="accidentFormData.areaOrName"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item :label="`${$t('可能时间、危害严重程度及其影响范围')}`">
                <el-input
                  type="textarea"
                  size="small"
                  :autosize="{ minRows: 2 }"
                  v-model="accidentFormData.reach"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item :label="`${$t('可能出现的征兆')}`">
                <el-input
                  type="textarea"
                  size="small"
                  :autosize="{ minRows: 2 }"
                  v-model="accidentFormData.symptom"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item :label="`${$t('可能引发的次生、衍生事故')}`">
                <el-input
                  type="textarea"
                  size="small"
                  :autosize="{ minRows: 2 }"
                  v-model="accidentFormData.trigger"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <!-- 事故风险分析end -->

      <!-- 应急工作职责start -->
      <div v-show="activeTab === '应急工作职责'">
        <el-form :model="jobDutyFormData" disabled label-width="110px" label-suffix=" :">
          <el-row>
            <el-col :span="24">
              <el-form-item :label="`${$t('应急工作职责')}`">
                <el-input
                  type="textarea"
                  size="small"
                  :autosize="{ minRows: 2 }"
                  v-model="jobDutyFormData.duty"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <!-- 应急工作职责end -->

      <!-- 应急处置start -->
      <div v-show="activeTab === '应急处置'">
        <el-form disabled :model="emergencyDisposalFormData" label-width="150px" label-suffix=" :">
          <el-row>
            <el-col :span="24">
              <el-form-item :label="`${$t('应急处置程序')}`">
                <el-input
                  type="textarea"
                  size="small"
                  :autosize="{ minRows: 2 }"
                  v-model="emergencyDisposalFormData.procedures"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item :label="`${$t('现场应急处置措施')}`">
                <el-input
                  type="textarea"
                  size="small"
                  :autosize="{ minRows: 2 }"
                  v-model="emergencyDisposalFormData.measure"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item :label="`${$t('报警电话')}`">
                <el-input
                  type="textarea"
                  size="small"
                  :autosize="{ minRows: 2 }"
                  v-model="emergencyDisposalFormData.phone"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item :label="`${$t('事故报告等内容')}`">
                <el-input
                  type="textarea"
                  size="small"
                  :autosize="{ minRows: 2 }"
                  v-model="emergencyDisposalFormData.content"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <!-- 应急处置end -->

      <!-- 注意事项start -->
      <div v-show="activeTab === '注意事项'">
        <el-form :model="announcementsFormData" label-width="100px" disabled label-suffix=" :">
          <el-row>
            <el-col :span="24">
              <el-form-item :label="`${$t('注意事项')}`">
                <el-input
                  type="textarea"
                  size="small"
                  :autosize="{ minRows: 2 }"
                  v-model="announcementsFormData.note"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <!-- 注意事项end -->

      <!-- 附件start -->
      <div v-show="activeTab === '附件'">
        <el-row>
          <FileInfo :fileIdList="fileIdList" />
        </el-row>
      </div>
      <!-- 附件end -->
    </div>
    <!-- 发布end -->
  </div>
</template>

<script>
import tableButtonGroup from '@/components/cockpit/TableButtonGroup'
import categoryTitle from '@/components/cockpit/CategoryTitle'
import dayjs from 'dayjs'
import { PlanApi } from '@wiz-api/emergency-management'
import { FileApi } from '@wiz-api/file-management'

const fileApi = new FileApi()
const planApi = new PlanApi()
const FileInfo = () => {
  return import('./FileInfo')
}

export default {
  name: 'OnsiteDisposalPlan',
  components: {
    tableButtonGroup,
    categoryTitle,
    FileInfo,
  },
  props: {
    planRowId: {
      type: String,
      default: '',
    },
    statusList: {
      type: Array,
      default: () => {
        return []
      },
    },
  },
  watch: {
    planRowId: {
      handler(newVal, oldVal) {
        newVal && this.getPlanDetail(newVal)
      },
      immediate: true,
    },
  },
  data() {
    return {
      tabList: ['基本信息', '事故风险分析', '应急工作职责', '应急处置', '注意事项', '附件'],
      activeTab: '基本信息',
      wfiles: '',
      dialogTitle: '', // 标题
      baseInfoFormData: {
        no: '', // 预案编号
        name: '', // 预案名称
        categoryName: '', // 预案类别
        categoryId: '',
        typeName: '', // 预案类型
        eascOrganizationID: '', // 所属部门
        version: '', // 版次
        summary: '', // 编制概要
      }, // 基本信息表单数据
      accidentFormData: {
        typeName: '', // 事故类型
        areaOrName: '', // 发生的区域、地点或装置的名称
        reach: '', // 可能时间、危害严重程度及其影响范围
        symptom: '', // 可能出现的征兆
        trigger: '', // 可能引发的次生、衍生事故
      }, // 事故风险分析表单数据
      jobDutyFormData: {
        duty: '', // 应急工作职责
      }, // 应急工作职责表单数据
      emergencyDisposalFormData: {
        procedures: '', // 应急处置程序
        measure: '', // 现场应急处置措施
        phone: '', // 报警电话
        content: '', // 事故报告等内容
      }, // 应急处置表单数据
      announcementsFormData: {
        note: '', // 注意事项
      }, // 注意事项表单数据
      saveLoading: false, // 保存按钮loading
      operateType: 'create', // 操作类型 read update create
      versionTableList: [], // 版次及记录列表数据
      departmentList: [], // 所属部门下拉框数据
      showApprovalPlanDialog: false, // 是否显示审批弹窗
      showRevisePlanDialog: false, // 是否显示提交修订弹窗
      showIssuePlanDialog: false, // 是否显示发布弹窗
      fileList: [], // 上传附件的列表
      fileIdList: [], // 上传成功文件的文件id
      fileMap: {}, // 上传成功文件名与文件id的映射
      approvalData: {}, // 审批需要的参数
      categoryList: [],
    }
  },
  methods: {
    // 从数据字典获取
    async getRegulationType() {
      const [err, res] = await dataCategoryApi.getListByCodes({
        codes: ['PlanCategory'],
        includeDetails: true,
      })
      if (err) return
      this.categoryList = res[0]?.dataItems
    },

    /**
     * @description 获取预案信息
     * @param {String} planId 预案id
     */
    async getPlanDetail(planId) {
      const [err, res] = await planApi.getPlan({
        id: planId,
      })
      if (!err) {
        this.fileIdList = _.map(res.planFiles, 'fileUrl')
        this.baseInfoFormData = res.plan
        this.accidentFormData = res.planAccident
        this.jobDutyFormData = res.planDuty
        this.emergencyDisposalFormData = res.planDispose
        this.announcementsFormData = res.planNote
        this.versionTableList = res.planVersions.filter((item) => {
          return [4, 5].includes(item.status)
        })
        _.forEach(this.versionTableList, (versionItem) => {
          if (versionItem.publishDate) {
            versionItem.publishDate = dayjs(new Date(versionItem.publishDate)).format(
              'YYYY-MM-DD HH:mm:ss'
            )
          }
          if (versionItem.executeDate) {
            versionItem.executeDate = dayjs(new Date(versionItem.executeDate)).format(
              'YYYY-MM-DD HH:mm:ss'
            )
          }
          if (versionItem.creationTime) {
            versionItem.creationTime = dayjs(new Date(versionItem.creationTime)).format(
              'YYYY-MM-DD HH:mm:ss'
            )
          }
        })
      }
    },

    /**
     * @description 获取上传文件
     */
    async getFile(id) {
      const [err, res] = await fileApi.getFileContent(id)
      if (!err) {
        return res
      }
      return null
    },

    /**
     * @description 查看该版次预案数据
     * @param {String} planId 预案id
     */
    viewLastVersion(row) {
      if (row.version === this.baseInfoFormData.version) return
      this.getPlanDetail(row.id)
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .el-form-item__label {
  text-align: right;
}
.tab-wrap {
  height: calc(100% - 48px);
  overflow-y: auto;
  overflow-x: hidden;
  padding-right: 10px;
  > div {
    height: calc(100% - 56px);
  }
}
</style>
